import { Ecommerce } from '../../../types/datalayer/pageview';
import { Recommendation } from '../../../types/recommendation';

export const getRecs = (recs: Recommendation[]): Ecommerce => {
  const e: Ecommerce = {
    currencyCode: 'BRL',
    impressions: [],
  };
  recs?.forEach(rec => {
    rec.products.forEach((product, i) => {
      e.impressions?.push({
        position: i + 1,
        id: product.id,
        list: `${rec.rule} | ${rec.type}`,
      });
    });
  });

  return e;
};
